import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpParams } from '@angular/common/http';
import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Mandant } from '../../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { ConfirmDeleteDialogComponent } from '../../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { SaveForAllDialogComponent } from '../../../dialogs/save-for-all-dialog/save-for-all-dialog.component';
import { Material } from '../material';
import { Anwendung } from './anwendung';
import { ArtikelAnwendungDialogComponent } from './artikel-anwendung-dialog/artikel-anwendung-dialog.component';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-artikel-anwendung',
    templateUrl: './artikel-anwendung.component.html',
    styleUrls: ['./artikel-anwendung.component.scss'],
})
export class ArtikelAnwendungComponent implements OnInit, OnChanges {
    tableDescriptor = new TableDescriptor();

    @Input('material') material: Material;

    @Input('mandanten') mandanten: Mandant[] = [];

    anwendungen: Anwendung[] = [];

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit() {}

    loadAnwendungen() {
        if (!this.localStorageService.currentUserHasPermission(1691)) {
            return;
        }
        if (this.material?.artikel_id) {
            let params = new HttpParams().set('artikel_id', this.material.artikel_id.toString());
            params = params.set('search', '');
            this.api.get(this.apiBaseUrl + 'anwendung/read_grouped.php', params).subscribe({
                next: response => {
                    this.anwendungen = response.records;
                },
                error: err => {
                    this.messageService.errorMessage(
                        'Anwendungen konnten nicht für den Artikel ' + this.material.artikel_me + ' geladen werden!',
                        err,
                    );
                },
            });
        }
    }

    reload() {
        this.loadAnwendungen();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.material) {
            // nur wenn sich der Artikel geändert hat
            this.loadAnwendungen();
        }
    }

    reorderList(event: CdkDragDrop<Anwendung[]>) {
        moveItemInArray(this.anwendungen, event.previousIndex, event.currentIndex);
        const obj = { records: this.anwendungen };
        this.api.updateGeneric(this.apiBaseUrl + 'anwendung/update_sort.php', obj).subscribe({
            next: () => {
                this.loadAnwendungen();
            },
            error: err => {
                this.messageService.errorMessage('Die Anwendungen konnten nicht neu sortiert werden!', err);
            },
        });
    }

    add() {
        this.openAnwendungDialog(null);
    }

    saveAndwendung(anwendung: Anwendung) {
        if (this.mandanten.length > 1) {
            // Array enthält nur Daten mit entspr. Berechtigung und bei Kiene
            let dialogRef = this.dialog.open(SaveForAllDialogComponent, {
                data: { availableMandanten: this.mandanten },
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    anwendung.mandanten_ids = result;
                    this.save(anwendung);
                }
            });
        } else {
            this.save(anwendung);
        }
    }

    save(anwendung: Anwendung) {
        this.api.updateGeneric(this.apiBaseUrl + 'anwendung/update_grouped.php', anwendung).subscribe({
            next: saved => {
                this.messageService.infoMessage('Die Anwendung ' + saved.anwendung + ' wurde erfolgreich gespeichert!');
                this.reload();
            },
            error: error => {
                this.messageService.errorMessage(
                    'Fehler! Die Anwendung ' + anwendung.anwendung + ' konnte nicht gespeichert werden! ',
                    error,
                );
            },
        });
    }

    openAnwendungDialog(anwendung: Anwendung) {
        const dialogRef = this.dialog.open(ArtikelAnwendungDialogComponent, {
            width: '800px',
            data: { material: this.material, anwendung: anwendung },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.saveAndwendung(response);
            }
        });
    }

    openDeleteDialog(anwendung: Anwendung) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: {
                title: anwendung.anwendung + ' löschen?',
                text: 'Wollen Sie die Anwendung ' + anwendung.anwendung + ' wirklich löschen?',
            },
        });

        dialogRef.afterClosed().subscribe({
            next: response => {
                if (response) {
                    this.api.deleteEntity(this.apiBaseUrl + 'anwendung/delete.php', anwendung).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Die Anwendung wurde erfolgreich gelöscht!');
                            this.reload();
                        },
                        error: error => {
                            this.messageService.errorMessage(
                                'Fehler! Es ein Problem beim Löschen der Anwendung aufgetreten! ',
                                error,
                            );
                        },
                    });
                }
            },
            error: () => {},
        });
    }
}
